<template>
  <p @click="goLogin">登陆</p>
</template>
<script>
import { mapActions } from "vuex";

export default {
  methods: {
    ...mapActions("user", ["login"]),
    goLogin() {
      this.login();
    },
  },
};
</script>
